import Header from "./components/layouts/Header";
import Menu from "./components/layouts/Menu";
import DemandesAchat from "./pages/demandeAchat/DemandesAchat";
import AddDemandeAchat from "./pages/demandeAchat/AddDemandeAchat";
import DemandeAchatDetail from "./pages/demandeAchat/DemandeAchatDetail";
import Addproduct from "./pages/productManagement/AddProduct";
import { Alert, Snackbar } from "@mui/material";
import Products from "./pages/productManagement/Products";
import Staff from "./pages/formule/Staff/Staff";
import Warehouses from "./pages/warehouse/Warehouses";
import { Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import ProductsBrand from "./pages/productManagement/ProductsBrand";
import ProductsFamily from "./pages/productManagement/ProductsFamily";
import ProductsSubFamily from "./pages/productManagement/ProductsSubFamily";
import ProductsCategory from "./pages/productManagement/ProductsCategory";
import AddSubFamilies from "./pages/productManagement/AddSubFamilies";
import AddCategories from "./pages/productManagement/AddCategories";
import AddWarehouse from "./pages/warehouse/AddWarehouse";
import ProductsByCategorieOrSubFamilyOrFamily from "./pages/productManagement/ProductsByCategorieOrSubFamilyOrFamily";
import ProductsByWarehouse from "./pages/productManagement/ProductsByWarehouse";
import ProductsTransaction from "./pages/productManagement/ProductsTransaction";
import ProductsTransactionDepot from "./pages/productManagement/ProductsTransactionDepot";
import ProductsByPrices from "./pages/productManagement/ProductsByPrices";
import ProductCodeBarcodes from "./pages/productManagement/ProductCodeBarcodes";
import AddSupplierQuotation from "./pages/productPurchase/AddSupplierQuotation";
import WarehouseTransfert from "./pages/warehouse/WarehouseTransfert";
import WarehouseTransfertAdmin from "./pages/warehouse/WarehouseTransfertAdmin";
import WarehouseTransfertExcel from "./pages/warehouse/WarehouseTransfertExcel";
import RfidTransfert from "./pages/rfid/RfidTransfert";
import RfidInventaire from "./pages/rfid/RfidInventaire";
import RfidAssociation from "./pages/rfid/RfidAssociation";
import RfidConfiguration from "./pages/rfid/RfidConfiguration";
import ConfirmTransfert from "./pages/warehouse/ConfirmTransfert";
import DemandeTransfertInformation from "./pages/warehouse/DemandeTransfertInformations";
import ReceiveTransfert from "./pages/warehouse/ReceiveTransfert";
import HomePage from "./Home";
import TransfertsByWarehouseManager from "./pages/warehouse/TransfertsByWarehouseManager";
import SupplierQuotations from "./pages/productPurchase/SupplierQuotations";
import ProductsByPurchaseDocument from "./pages/productManagement/ProductsByPurchaseDocument";
import AddBDC from "./pages/productPurchase/AddBDC";
import BDCs from "./pages/productPurchase/BDCs";
import AddFacture from "./pages/productPurchase/AddFacture";
import Factures from "./pages/productPurchase/Factures";
import AddPurchaseOrder from "./pages/productPurchase/AddPurchaseOrder";
import PurchaseOrders from "./pages/productPurchase/PurchaseOrders";
import ReceiveAPurchaseOrder from "./pages/productPurchase/ReceiveAPurchaseOrder";
import GenerateFactureForPurchasesOrders from "./pages/productPurchase/GenerateFactureForPurchasesOrders";
import PayementAllBills from "./components/finance/PayementAllBills";
import PayerAvanceBC from "./components/finance/payement/PayerAvanceBC";
import Login from "./Login";
import Integration from "./pages/formule/Integrations";
import UploadExcelProductSellNewProducts from "./pages/formule/partenaire/UploadExcelProductSellNewProducts";
import AddClientSociete from "./pages/formule/partenaire/AddClientSociete";
import ClientSociete from "./pages/formule/partenaire/ClientSociete";
import AddPersonnel from "./pages/formule/Staff/AddPersonnel";
import AllPersonnels from "./pages/formule/Staff/AllPersonnels";
import AddBanqueAccount from "./pages/banque/AddBanqueAccount";
import AllBanqueAccounts from "./pages/banque/AllBanqueAccounts";
import Predection from "./pages/productPurchase/Predection";
import AddAdminSociete from "./pages/formule/partenaire/AddAdminSociete";
import AdminSocietes from "./pages/formule/partenaire/AdminSocietes";
import AddAdminAccount from "./pages/formule/Staff/AddAdminAccount";
import AllAdminsAccount from "./pages/formule/Staff/AllAdminsAccount";
import SocieteAndUserService from "./services/societeAndUser";
import AuthentificationService from "./services/authentification";
import UpdateProduct from "./pages/productManagement/UpdateProduct";
import AddSpecificityToCategory from "./pages/productManagement/AddSpecificityToCategory";
import SpecifitiesToCategory from "./pages/productManagement/SpecifitiesToCategory";
import AddFamily from "./pages/productManagement/AddFamily";
import AddSpecificityToCompletedProduct from "./pages/productManagement/AddSpecificityToCompletedProduct";
import ManufacturingBatch from "./pages/productManagement/ManufacturingBatch";
import AddManufacturingBatch from "./pages/productManagement/AddManufacturingBatch";
import AddRate from "./pages/productPurchase/AddRate";
import AllRates from "./pages/productPurchase/AllRates";
import AddTaxAndChargeToFacture from "./pages/productPurchase/AddTaxAndChargeToFacture";
import UpdatePersonnel from "./pages/formule/Staff/UpdatePersonnel";
import LivraisonDocumentToStock from "./pages/productPurchase/LivraisonDocumentToStock";
import WarehouseMouvement from "./pages/warehouse/WarehouseMouvement";
import AllDevis from "./pages/ProductSellBTOB/AllDevis";
import AddDevis from "./pages/ProductSellBTOB/AddDevis";
import AddDevisPrice from "./pages/ProductSellBTOB/AddDevisPrice";
import ProductSell from "./pages/ProductSellBTOB/ProductSell";
import AddProductStockToSell from "./pages/ProductSellBTOB/AddProductStockToSell";
import BDCSell from "./pages/ProductSellBTOB/BDCSell";
import SuiviLivraisons from "./pages/ProductSellBTOB/SuiviLivraisons";
import BDCSellUpdate from "./pages/ProductSellBTOB/BDCSellUpdate";
import MaSociete from "./pages/MaSociete";
import AddBDCSell from "./pages/ProductSellBTOB/AddBDCSell";
import AddBDCSellDepot from "./pages/ProductSellBTOB/AddBDCSellDepot";
import AllFactureSell from "./pages/ProductSellBTOB/AllFactureSell";
import AddFactureSell from "./pages/ProductSellBTOB/AddFactureSell";
import AddFactureSellDepot from "./pages/ProductSellBTOB/AddFactureSellDepot";
import SendPurchaseOrder from "./pages/ProductSellBTOB/SendPurchaseOrder";
import AddBCListSociete from "./components/AchatService/AddBCListSociete";
import AddBCAchat from "./components/AchatService/AddBCAchat";
import ViewBCDetails from "./components/AchatService/ViewBCDetails";
import ProductsBySaleDocument from "./pages/ProductSellBTOB/ProductsBySaleDocument";
import ReturnSalesOrder from "./pages/ProductSellBTOB/ReturnSalesOrder";
import ListSocieteForBC from "./components/AchatService/ListSocieteForBC";
import ListBCValidated from "./components/AchatService/ListBCValidated";
import AddBillListSociete from "./components/AchatService/AddBillListSociete";
import Pack from "./pages/Marketing/Pack/Pack";
import AddPack from "./pages/Marketing/Pack/AddPack";
import AddDiscount from "./pages/Marketing/Discount/AddDiscount";
import Discounts from "./pages/Marketing/Discount/Discounts";
import Dashboard from "./pages/Marketing/Dashboard";
import PageClient from "./pages/Marketing/Client/PageClient";
import AddClient from "./pages/Marketing/Client/AddClient";
import PageCampagne from "./pages/Marketing/Campagne/PageCampagne";
import PageCampagneR from "./pages/Marketing/Campagne/CampagneReseauxSociaux/PageCampagneR";
import AddCampagneR from "./pages/Marketing/Campagne/CampagneReseauxSociaux/AddCampagneR";
import StatCampagnePhysique from "./pages/Marketing/Campagne/CampagnePhysique/StatCampagnePhysique";
import PageCampagnePhy from "./pages/Marketing/Campagne/CampagnePhysique/PageCampagnePhy";
import AddCampagnePhy from "./pages/Marketing/Campagne/CampagnePhysique/AddCampagnePhy";
import PageCampagneE from "./pages/Marketing/Campagne/CampagneEmail/PageCampagneE";
import AddCampagneE from "./pages/Marketing/Campagne/CampagneEmail/AddCampagneE";
import EditCampagneE from "./pages/Marketing/Campagne/CampagneEmail/EditCampagneE";
import PageCampagneS from "./pages/Marketing/Campagne/CampagneSMS/PageCampagneS";
import PagePublication from "./pages/Marketing/Publication/PagePublication";
import AddPublication from "./pages/Marketing/Publication/AddPublication";
import StatPublication from "./pages/Marketing/Publication/StatPublication";
import ListeOffres from "./pages/Marketing/Offres/ListeOffres";
import AddCampagneS from "./pages/Marketing/Campagne/CampagneSMS/AddCampagneS";
import EditCampagneS from "./pages/Marketing/Campagne/CampagneSMS/EditCampagneS";
import StatCampagneSMS from "./pages/Marketing/Campagne/CampagneSMS/StatCampagneSMS";
import AddDeclencheur from "./pages/Marketing/Discount/AddDeclencheur";
import ProductionSchedulePage from "./pages/Production/production/scheduler/pages/ProductionSchedulePage";
import StatCampagneR from "./pages/Marketing/Campagne/CampagneReseauxSociaux/StatCampagneR";
import StatCampagneE from "./pages/Marketing/Campagne/CampagneEmail/StatCampagneE";
import PayerAvanceBCSell from "./components/finance/payement/PayerAvanceBCSell";
import CashRegister from "./pages/ProductSellBTOC/CashRegister";
import Shop from "./pages/ProductSellBTOC/Shop";
import AddShop from "./pages/ProductSellBTOC/AddShop";
import UploadExcel from "./pages/formule/partenaire/UploadExcel";
import ClientContract from "./pages/formule/partenaire/ClientContract";
import PaiementsAbonnement from "./pages/formule/partenaire/PaiementsAbonnement";
import Support from "./pages/support/Support";
import WorkOrderDetailsPage from "./pages/Production/production/workOrder/pages/WorkOrderDetailsPage";
import ProductsListPage from "./pages/Production/productionResources/product/pages/ProductsListPage";
import WorkstationList from "./pages/Production/productionResources/workstation/pages/WorkstationList";
import NewWorkstation from "./pages/Production/productionResources/workstation/pages/NewWorkstation";
import WorkstationDetails from "./pages/Production/productionResources/workstation/pages/WorkstationDetails";
import OperationsList from "./pages/Production/productionResources/operation/pages/OperationsList";
import NewOperation from "./pages/Production/productionResources/operation/pages/NewOperation";
import OperationsDetails from "./pages/Production/productionResources/operation/pages/OperationsDetails";
import BOMList from "./pages/Production/productionResources/billOfMaterials/pages/BOMList";
import NewBOM from "./pages/Production/productionResources/billOfMaterials/pages/NewBOM";
import AllUnitOfMesure from "./pages/Production/productionResources/UnitOfMesure/AllUnitOfMesure";
import NewUnitOfMesure from "./pages/Production/productionResources/UnitOfMesure/NewUnitOfMesure";
import ProductionOrderList from "./pages/Production/production/productionOrder/pages/ProductionOrderList";
import NewProductionOrder from "./pages/Production/production/productionOrder/pages/NewProductionOrder";
import ProductionOrderDetails from "./pages/Production/production/productionOrder/pages/ProductionOrderDetails";
import BOMDetails from "./pages/Production/productionResources/billOfMaterials/pages/BOMDetails";
import UpdateBOM from "./pages/Production/productionResources/billOfMaterials/pages/UpdateBOM";
import UpdateClientSociete from "./pages/formule/partenaire/UpdateClientSociete";
import AddGroupeSociete from "./pages/formule/partenaire/AddGroupeSociete";
import UpdateGroupe from "./pages/formule/partenaire/UpdateGroupe";
import ValidateDevisToBCAchat from "./pages/productPurchase/ValidateDevisToBCAchat";
import ValidateBCtoFactureAchat from "./pages/productPurchase/ValidateBCtoFactureAchat";
import ValidateDevisToBCVente from "./pages/ProductSellBTOB/ValidateDevisToBCVente";
import ValidateBCtoFactureVente from "./pages/ProductSellBTOB/ValidateBCtoFactureVente";
import AddContactSociete from "./pages/formule/partenaire/AddContactSociete";
import RecieveAllProductsPurchaseOrder from "./pages/productPurchase/RecieveAllProductsPurchaseOrder";
import SendAllProductsPurchaseOrder from "./pages/ProductSellBTOB/SendAllProductsPurchaseOrder";
import TransactionsBankAccount from "./pages/banque/TransactionsBankAccount";
import EditBDCSell from "./pages/ProductSellBTOB/ProductsBySaleDocumentEdit";
import ZoneSociete from "./pages/formule/partenaire/ZoneSociete";
import PlaningZone from "./pages/formule/partenaire/PlanZone";
import SocieteByZone from "./pages/formule/partenaire/SocieteByZone";

// RESSOURCE HUMAINES
import EmployeeFolder from "./pages/RessourcesHumaines/RhPages/employeeComponent/EmployeeFolder";
import PaiementSettings from "./pages/RessourcesHumaines/Settings/PaiementSettings";
import Paiement from "./pages/RessourcesHumaines/RhPages/PaiementComponent/Paiement";
import DashboardRH from "./pages/RessourcesHumaines/DashboardRH";
import EmployeeList from "./pages/RessourcesHumaines/RhPages/employeeComponent/EmployeeList";
import AddEmployee from "./pages/RessourcesHumaines/RhPages/employeeComponent/AddEmployee";
import ContractList from "./pages/RessourcesHumaines/RhPages/contractComponent/ContractList";
import AddContract from "./pages/RessourcesHumaines/RhPages/contractComponent/AddContract";
import ContractDetail from "./pages/RessourcesHumaines/RhPages/contractComponent/ContractDetail";
import CrewList from "./pages/RessourcesHumaines/RhPages/CrewComponent/CrewList";
import AddCrew from "./pages/RessourcesHumaines/RhPages/CrewComponent/AddCrew";
import EmployeebyCrew from "./pages/RessourcesHumaines/RhPages/CrewComponent/EmployeebyCrew";
import Missionlist from "./pages/RessourcesHumaines/RhPages/MissionOrderComponent/Missionlist";
import AddMission from "./pages/RessourcesHumaines/RhPages/MissionOrderComponent/AddMission";
import Employeemissionlist from "./pages/RessourcesHumaines/RhPages/MissionOrderComponent/Employeemissionlist";
import InternMissionlist from "./pages/RessourcesHumaines/RhPages/ContratDePartage/InternMissionlist";
import Addinternmission from "./pages/RessourcesHumaines/RhPages/ContratDePartage/Addinternmission";
import MissionDetails from "./pages/RessourcesHumaines/RhPages/MissionOrderComponent/MissionDetails";
import TimePlanning from "./pages/RessourcesHumaines/RhPages/CrewComponent/TimePlanning";
import InternMissionDetails from "./pages/RessourcesHumaines/RhPages/ContratDePartage/InternMissionDetails";
import Departmentlist from "./pages/RessourcesHumaines/RhPages/DepartmentComponent/Departmentlist";
import AddDepartment from "./pages/RessourcesHumaines/RhPages/DepartmentComponent/AddDepartment";
import CrewbyDepartment from "./pages/RessourcesHumaines/RhPages/DepartmentComponent/CrewbyDepartment";
import AttendanceList from "./pages/RessourcesHumaines/RhPages/AttendanceComponent/AttendanceList";
import AllLeaveRequests from "./pages/RessourcesHumaines/RhPages/LeaveRequestsComponent/AllLeaveRequests";
import EmployeeDashboard from "./pages/RessourcesHumaines/EmployeeDashboard";
import EmployeeLeaveRequests from "./pages/RessourcesHumaines/EmployeePages/LeaveEmployee/EmpLeaveRequestList";
import LeaveRequest from "./pages/RessourcesHumaines/EmployeePages/LeaveEmployee/LeaveRequest";
import PostList from "./pages/RessourcesHumaines/Settings/postComponent/PostList";
import AddPost from "./pages/RessourcesHumaines/Settings/postComponent/AddPost";
import ContractTypeList from "./pages/RessourcesHumaines/Settings/contractTypeComponent/ContractTypeList";
import AddContractType from "./pages/RessourcesHumaines/Settings/contractTypeComponent/AddContractType";
import Primelist from "./pages/RessourcesHumaines/Settings/PrimeComponent/Primelist";
import Addprime from "./pages/RessourcesHumaines/Settings/PrimeComponent/Addprime";
import LeaveTypeList from "./pages/RessourcesHumaines/Settings/LeaveTypeComponent/LeaveTypeList";
import AddLeave from "./pages/RessourcesHumaines/Settings/LeaveTypeComponent/AddLeave";
import EmployeeCrew from "./pages/RessourcesHumaines/EmployeePages/CrewEmployee/EmployeeCrew";
import PayementsByBankAccount from "./pages/banque/PayementsByBankAccount";
import HistoriqueFicheDePaie from "./pages/RessourcesHumaines/RhPages/employeeComponent/HistoriqueFicheDePaie";
import PayementSalaires from "./pages/payement/PayementSalaires";
import AddNewAvance from "./pages/payement/Salaires/Avances/AddNewAvance";
import FicheDePaieSelonSalaire from "./pages/RessourcesHumaines/RhPages/PaiementComponent/ficheDePaieSelonSalaire";
import SendProductionOrder from "./pages/Production/ProductionOrderValidation/SendProductionOrder";

import KPIProductionOrder from "./pages/Production/production/KPIProduction/KPIProductionOrder";

import GetFinalProductionOrder from "./pages/Production/ProductionOrderValidation/GetFinalProductionOrder";
import ListBonReception from "./pages/warehouse/ListBonReception";
import ListBonSortie from "./pages/warehouse/ListBonSortie";
import ListBonRetour from "./pages/warehouse/ListBonRetour";
import PayementBillDetails from "./components/finance/PayementBillDetails";
import PayementBillVenteDetails from "./components/finance/PayementBillVenteDetails";
import ListBillVenteV2 from "./components/finance/ListBillVenteV2";
import ListClientSolde from "./pages/payement/Solde/ListClientSolde";
import AllClient from "./pages/payement/Solde/AllClient";
import ListFournisseurSolde from "./pages/payement/Solde/ListFournisseurSolde";
import DetailsSoldeClient from "./pages/payement/Solde/DetailsSoldeClient";
import DetailsSoldeFournisseur from "./pages/payement/Solde/DetailsSoldeFournisseur";
import TransfertEntreComptes from "./pages/banque/TransfertEntreComptes";
import TransfertEntreComptesPusInfo from "./pages/banque/TransfertEntreComptesPusInfo";
import AddTransfertBanqueAccounts from "./pages/banque/AddTransfertBanqueAccounts";
import PayementsAgenda from "./pages/payement/PayementsAgenda";
import PayementAgendaAllAccounts from "./pages/payement/PayementAgendaAllAccounts";
import WalletClient from "./pages/banque/WalletClient";
import WalletFournisseur from "./pages/banque/WalletFournisseur";
import AddWalletClient from "./pages/banque/AddWalletClient";
import AddWalletFournisseur from "./pages/banque/AddWalletFournisseur";
import ChargerWallet from "./pages/banque/ChargerWallet";
import ListSocieteAchatFN from "./pages/payement/ListSocieteAchatFN";
import ListBillAchatV2 from "./components/finance/ListBillAchatV2";
import ListSocieteVenteFN from "./pages/payement/ListSocieteVenteFN";
import PayementGroupe from "./pages/payement/PayementGroupe";
import PayementCharges from "./pages/payement/Charges/PayementCharges";
import AddCharge from "./pages/payement/Charges/AddCharge";
import AddPayementCharge from "./pages/payement/Charges/AddPayementCharge";
import ChargerWalletFournisseur from "./pages/banque/ChargerWalletFournisseur";
import ClientWalletAndSolde from "./pages/payement/ClientWalletAndSolde";
import AddNewSalaire from "./pages/payement/Salaires/FicheDePaie/AddNewSalaire";
import PayerSalaire from "./pages/payement/Salaires/FicheDePaie/PayerSalaire";
import ListBordereau from "./pages/payement/Bordereau/ListBordereau";
import AllInventaire from "./pages/warehouse/Inventaire/AllInventaire";
import AddInventaire from "./pages/warehouse/Inventaire/AddInventaire";
import DetailsInventaire from "./pages/warehouse/Inventaire/DetailsInventaire";
import ListConditionsCommercialsB2B from "./pages/Marketing/ConditionsCommercialB2B/ListConditionsCommercialsB2B";
import AddConditionCommercial from "./pages/Marketing/ConditionsCommercialB2B/AddConditionCommercial";
import ListConditionsCommercialsB2BTiers from "./pages/Marketing/ConditionsCommercialB2B/ListConditionsCommercialsB2BTiers";
import AddConditionCommercialTiersClient from "./pages/Marketing/ConditionsCommercialB2B/AddConditionCommercialTiersClient";
import AddConditionCommercialTiersFournisseur from "./pages/Marketing/ConditionsCommercialB2B/AddConditionCommercialTiersFournisseur";
import AddTesteur from "./pages/Marketing/Pack/AddTesteur";
import KPISale from "./pages/ProductSellBTOB/KPISale";
import KPISaleDevis from "./pages/ProductSellBTOB/KPISaleDevis";
import KPIPayements from "./pages/payement/KPIPayements";
import KPISaleProduct from "./pages/ProductSellBTOB/KPISaleProduct";
import KPIAchat from "./pages/productPurchase/KPIAchat";
import PrixAchat from "./pages/productPurchase/PrixAchat";
import AjouterAchats from "./pages/productPurchase/AjouterAchats";
import Abonnements from "./pages/Marketing/Offres/Abonnements";
import AddAbonnement from "./pages/Marketing/Offres/AddAbonnement";
import OperationExecution from "./pages/Production/production/OperationExecution/OperationExecution";
import DetailsOperationExecution from "./pages/Production/production/OperationExecution/DetailsOperationExecution";
import CartesCadeau from "./pages/Marketing/Offres/CartesCadeau";
import AddCarteCadeau from "./pages/Marketing/Offres/AddCarteCadeau";
import WorkOrderForPOList from "./pages/Production/production/productionOrder/pages/WorkOrderForPOList";
import WorkOrdersSteps from "./pages/Production/production/productionOrder/pages/WorkOrdersSteps";
import FicheClient from "./pages/payement/Solde/FicheClient";
import DetailsImpayesClient from "./pages/payement/Impayes/DetailsImpayesClient";
import BordereauDetails from "./pages/payement/Bordereau/BordereauDetails";
import DataTableBordereauDetails from "./pages/payement/Bordereau/DataTableBordereauDetails";
import ListFactureFicheClient from "./pages/payement/Solde/DetailsFicheClient/ListFactureFicheClient";
import DetailsPayementsClient from "./pages/payement/Solde/DetailsFicheClient/DetailsPayementsClient";
import ClientsVente from "./pages/ProductSellBTOC/ClientsVente";
import TicketShop from "./pages/ProductSellBTOC/TicketShop";
import TicketCaisse from "./pages/ProductSellBTOC/TicketCaisse";
import ClientsVenteDetails from "./pages/ProductSellBTOC/ClientsVenteDetails";
import ManagerShop from "./pages/ProductSellBTOC/ManagerShop";
import ShopManagers from "./pages/Managers/ShopManagers";
import CashRegisterManagers from "./pages/Managers/CashRegisterManagers";
import AllBanqueAccountsManagers from "./pages/Managers/AllBanqueAccountsManagers";
import WarehousesManagers from "./pages/Managers/WarehousesManagers";
import JournalCaisse from "./pages/ProductSellBTOC/JournalCaisse";
import AddPackComposition from "./pages/Marketing/Pack/AddPackComposition";
import AlimentationCaisseManagers from "./pages/Managers/AlimentationCaisseManagers";
import KPIProduits from "./pages/productManagement/KPIProduits";
import KPIProduitsDetails from "./pages/productManagement/KPIProduitsDetails";
import AddMagasin from "./pages/productPurchase/AddMagasin";
import ColisLivraison from "./pages/ProductSellBTOB/ColisLivraison";
import AddColisLivraison from "./pages/ProductSellBTOB/AddColisLivraison";
import ConfigColis from "./pages/ProductSellBTOB/ConfigColis";
import AddConfigColis from "./pages/ProductSellBTOB/AddConfigColis";
import UploadExcelProductSell from "./pages/formule/partenaire/UploadExcelProductSell";
import UploadExcelStockSell from "./pages/formule/partenaire/UploadExcelStockSell";
import UploadEmployeExcel from "./pages/formule/partenaire/UploadEmployeExcel";
import AddZone from "./pages/formule/partenaire/AddZone";
import BSZone from "./pages/formule/partenaire/BSZone";
import WorkOrdersDetails from "./pages/Production/production/productionOrder/pages/WorkOrdersDetails";
import UpdateZone from "./pages/formule/partenaire/UpdateZone";
import BCProduct from "./pages/ProductSellBTOB/BCProduct";
import TicketDetails from "./pages/ProductSellBTOC/TicketDetails";
import PackDetails from "./pages/Marketing/Pack/PackDetails";
import FactureSellEtat from "./pages/ProductSellBTOB/FactureSellEtat";
import EtatMagasin from "./pages/ProductSellBTOC/EtatMagasin";
import Recap from "./pages/formule/partenaire/Recap";
import EtatStocks from "./pages/warehouse/EtatStocks";
import EtatStocksDetails from "./pages/warehouse/EtatStocksDetails";
import AnalyseStock from "./pages/warehouse/AnalyseStock";
import AnalyseStockVente from "./pages/warehouse/AnalyseStockVente";
import CartesCadeauDetails from "./pages/Marketing/Offres/CartesCadeauDetails";
import AbonnementDetails from "./pages/Marketing/Offres/AbonnementDetails";
import AddFactureAvrDepot from "./pages/ProductSellBTOB/AddFactureAvrDepot";
import WorkstationOperations from "./pages/Production/productionResources/workstation/pages/WorkstationOperations";
import DetailsOperationExecutionBySup from "./pages/Production/production/OperationExecution/DetailsOperationExecutionBySup";
import AddConfigEmailsSociete from "./pages/ProductSellBTOB/AddConfigEmailsSociete";
import ConfigEmailsSociete from "./pages/ProductSellBTOB/ConfigEmailsSociete";
import UpdateOperation from "./pages/Production/productionResources/operation/pages/UpdateOperation";
import PromoSurCaisse from "./pages/Marketing/Offres/PromoSurCaisse";
import AddPromo from "./pages/Marketing/Offres/AddPromo";
import PromoGroupDetails from "./pages/Marketing/Offres/PromoGroupDetails";
import ScannerProduit from "./pages/warehouse/ScannerProduit";
import RechercheTicket from "./pages/ProductSellBTOC/RechercheTicket";
import PlanAllZone from "./pages/formule/partenaire/PlanAllZone";
import UpdateDeclencheur from "./pages/Marketing/Discount/UpdateDeclencheur";
import KPIProduitsB2C from "./pages/ProductSellBTOC/KPIProduitsB2C";
import FicheFournisseur from "./pages/payement/Solde/FicheFournisseur";
import ListFactureFicheFournisseur from "./pages/payement/Solde/DetailsFicheFournisseur/ListFactureFicheFournisseur";
import DetailsPayementsFournisseur from "./pages/payement/Solde/DetailsFicheFournisseur/DetailsPayementsFournisseur";
import DetailsImpayesFournisseur from "./pages/payement/Impayes/DetailsImpayesFournisseur";
import CreditShop from "./pages/ProductSellBTOC/CreditShop";
import EchangePaiementTicket from "./pages/ProductSellBTOC/EchangePaiementTicket";
import PayerTraite from "./pages/payement/PayerTraite";
import EchangePaiementTraite from "./pages/payement/EchangePaiementTraite";
import TraiteShop from "./pages/ProductSellBTOC/TraiteShop";
import ExtraitBankAccount from "./pages/banque/ExtraitBankAccount";
import AddFactureImport from "./pages/productPurchase/AddFactureImport";
import ProductSearchWarehouses from "./pages/warehouse/ProductSearchWarehouses";
import ProductDetailsSearch from "./pages/warehouse/ProductDetailsSearch";
import WarehouseStats from "./pages/warehouse/WarehouseStats";
function App() {
  const [accessIsDenied, setAccessIsDenied] = useState("notConnected");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [showElement, setShowElement] = useState([]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  useEffect(() => {
    if (localStorage.getItem("accessIsDenied") == null) {
      localStorage.setItem("accessIsDenied", "notConnected");
      setAccessIsDenied("notConnected");
    } else setAccessIsDenied(localStorage.getItem("accessIsDenied"));

    // let user = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }

    SocieteAndUserService.isAvailableUserAndSociete()
      .then((response) => {
        if (Object.keys(response.data)[0] === "notAvailable") {
          setOpenErrorAlert(true);
          setErrorAlertText(
            "Info : vous n'avez pas le droit d'accéder à votre espace "
          );
          setTimeout(function () {
            AuthentificationService.logout().then((response) => {
              if (Object.keys(response.data) === "success") {
                localStorage.setItem("accessIsDenied", "notConnected");
                localStorage.removeItem("status");

                window.location.href = "/login";
              }

              if (Object.keys(response.data) === "failed") {
              }
            });
          }, 2000);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : Vous devez reconnecter");
      });
  }, []);

  if (accessIsDenied === "connected")
    return (
      <div className="wrapper">
        <Header></Header>
        <Menu>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/integration" element={<Integration />}></Route>
            <Route path="/uploadExcelNewProducts" element={<UploadExcelProductSellNewProducts />} />
            <Route path="/addAdminAccount" element={<AddAdminAccount />} />
            <Route path="/ajoutertiers" element={<AddClientSociete />} />
            <Route path="/AllClient" element={<AllClient />} />
            <Route path="/ajouterzone" element={<AddZone />} />
            <Route path="/BSZone" element={<BSZone />} />
            <Route path="/PlaningZone" element={<PlaningZone />} />
            <Route path="/EtatStocks" element={<EtatStocks />} />
            <Route path="/EtatStocksDetails" element={<EtatStocksDetails />} />
            <Route path="/analyseStock" element={<AnalyseStock />} />
            <Route path="/analyseStockVente" element={<AnalyseStockVente />} />
            <Route path="/updateZone" element={<UpdateZone />} />
            <Route path="/BCProduct" element={<BCProduct />} />
            <Route path="/ajoutergroupe" element={<AddGroupeSociete />} />
            <Route path="/uploadExcel" element={<UploadExcel />} />
            <Route path="/contratAbonnement" element={<ClientContract />} />
            <Route path="/paiementsAbonnement" element={<PaiementsAbonnement />} />
            <Route path="/support" element={<Support />} />
            <Route
              path="/uploadExcelProduct"
              element={<UploadExcelProductSell />}
            />
            <Route
              path="/uploadExcelStock"
              element={<UploadExcelStockSell />}
            />
            <Route
              path="/uploadEmployeExcel"
              element={<UploadEmployeExcel />}
            />
            <Route path="/modifiergroupe" element={<UpdateGroupe />} />
            <Route path="/modifiertiers" element={<UpdateClientSociete />} />
            <Route path="/AddPersonnel" element={<AddPersonnel />} />
            <Route path="/updatePersonnel" element={<UpdatePersonnel />} />
            <Route path="/addAdminSociete" element={<AddAdminSociete />} />
            <Route path="/adminSociete" element={<AdminSocietes />} />
            <Route path="/Personnels" element={<AllPersonnels />} />
            <Route path="/allAdminsAccount" element={<AllAdminsAccount />} />
            <Route path="/tiers" element={<ClientSociete />} />
            <Route path="/zone" element={<ZoneSociete />} />
            <Route path="/PlanningAllZones" element={<PlanAllZone />} />

            <Route path="/SocieteByZone" element={<SocieteByZone />} />
            <Route path="/PackDetails" element={<PackDetails />} />
            <Route path="/contacttiers" element={<AddContactSociete />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/:isAccessDenied" element={<HomePage />} />
            <Route path="/addProduct" element={<Addproduct />} />
            <Route path="/updateProduct" element={<UpdateProduct />} />
            <Route
              path="/addSpecificityToProduct"
              element={<AddSpecificityToCompletedProduct />}
            />
            <Route path="/Lots" element={<ManufacturingBatch />} />
            <Route path="/addLot" element={<AddManufacturingBatch />} />
            <Route
              path="/addSpecificityToCategory"
              element={<AddSpecificityToCategory />}
            />
            <Route
              path="/specificities"
              element={<SpecifitiesToCategory />}
            ></Route>
            <Route path="/products" element={<Products />}></Route>
            <Route path="/KPIProduits" element={<KPIProduits />} />
            <Route
              path="/KPIProduitsDetails/:type"
              element={<KPIProduitsDetails />}
            />
            <Route path="/staff" element={<Staff />} />
            <Route path="/warehouses" element={<Warehouses />} />
            <Route path="/inventaires" element={<AllInventaire />} />
            <Route path="/addInventaire" element={<AddInventaire />} />
            <Route path="/detailsInventaire" element={<DetailsInventaire />} />
            <Route
              path="/getListProductsInfo"
              element={<ProductsByCategorieOrSubFamilyOrFamily />}
            />
            <Route
              path="/warehouseProducts"
              element={<ProductsByWarehouse />}
            />
            <Route
              path="/updateDeclencheur"
              element={<UpdateDeclencheur />}
            />

            <Route
              path="/TransactionProducts"
              element={<ProductsTransaction />}
            />
            <Route element={<KPIProduitsB2C />} path="/kpiProduitsMagasin" />


            <Route
              path="/TransactionProductsDepot"
              element={<ProductsTransactionDepot />}
            />

            <Route
              path="/scannerProduit"
              element={<ScannerProduit />}
            />
              <Route
              path="/searchProductsWarehouse"
              element={<ProductSearchWarehouses />}
            />

                   <Route
              path="/productDetailsSearch"
              element={<ProductDetailsSearch />}
            />
            <Route path="/ticket-detail" element={<TicketDetails />} />
            <Route
              path="/warehouseProductsByPrices"
              element={<ProductsByPrices />}
            />
            <Route
              path="/warehouseProductCode"
              element={<ProductCodeBarcodes />}
            />
            <Route
              path="/informationsTransfert"
              element={<DemandeTransfertInformation />}
            />
            <Route path="/Brands" element={<ProductsBrand />} />
            <Route path="/families" element={<ProductsFamily />} />
            <Route path="/addFamily" element={<AddFamily />} />
            <Route path="/addBanqueAccount" element={<AddBanqueAccount />} />
            <Route path="/allBanqueAccounts" element={<AllBanqueAccounts />} />
            <Route
              path="/transfertsEntreCompte"
              element={<TransfertEntreComptes />}
            />
            <Route
              path="/transfertEntreComptesPusInfo"
              element={<TransfertEntreComptesPusInfo />}
            />
            <Route
              path="/addTransfertsEntreCompte"
              element={<AddTransfertBanqueAccounts />}
            />
            <Route path="/agendaPayement" element={<PayementsAgenda />} />
            <Route
              path="/allAgendaPayement"
              element={<PayementAgendaAllAccounts />}
            />
            {/* wallet */}
            <Route path="/walletClient" element={<WalletClient />} />
            <Route path="/walletFournisseur" element={<WalletFournisseur />} />
            <Route path="/addWalletClient" element={<AddWalletClient />} />
            <Route
              path="/addWalletFournisseur"
              element={<AddWalletFournisseur />}
            />
            <Route path="/chargerWallet" element={<ChargerWallet />} />
            <Route
              path="/chargerWalletFournisseur"
              element={<ChargerWalletFournisseur />}
            />
            <Route
              path="/getTransactionsByBankAccount"
              element={<TransactionsBankAccount />}
            />

              <Route
              path="/getExtraitByBankAccount"
              element={<ExtraitBankAccount />}
            />
            <Route
              path="/getPayementsByBankAccount"
              element={<PayementsByBankAccount />}
            />
            <Route path="/subFamilies" element={<ProductsSubFamily />} />
            <Route path="/categories" element={<ProductsCategory />} />
            <Route path="/addSubFamily" element={<AddSubFamilies />} />
            <Route path="/addCategory" element={<AddCategories />} />
            <Route path="/addWarehouse" element={<AddWarehouse />} />
            <Route path="/confirmTransfert" element={<ConfirmTransfert />} />
            <Route path="/addQuotation" element={<AddSupplierQuotation />} />
            <Route
              path="/validateDevisBDC"
              element={<ValidateDevisToBCAchat />}
            />
            <Route
              path="/validateBDCFacture"
              element={<ValidateBCtoFactureAchat />}
            />
            <Route path="/addTax" element={<AddRate />} />
            <Route path="/taxes" element={<AllRates />} />
            <Route
              path="/addTaxAndCharge"
              element={<AddTaxAndChargeToFacture />}
            />
            <Route
              path="/receivePurchaseOrder"
              element={<ReceiveAPurchaseOrder />}
            />
            <Route
              path="/receiveProducts"
              element={<RecieveAllProductsPurchaseOrder />}
            />
            <Route
              path="/warehouseTransfert"
              element={<WarehouseTransfert />}
            />
            <Route
              path="/warehouseTransfertAdmin"
              element={<WarehouseTransfertAdmin />}
            />
            <Route path="/receiveTransfert" element={<ReceiveTransfert />} />
            <Route
              path="/transfertsByWarehouseManager"
              element={<TransfertsByWarehouseManager />}
            />
            <Route path="/rfidTransfert" element={<RfidTransfert />} />
            <Route path="/rfidInventaire" element={<RfidInventaire />} />
            <Route path="/rfidAssociation" element={<RfidAssociation />} />
            <Route path="/rfidConfiguration" element={<RfidConfiguration />} />
            <Route
              path="/warehouseTransfertExcel"
              element={<WarehouseTransfertExcel />}
            />
            <Route path="/kpiachat" element={<KPIAchat />} />
            <Route path="/prixAchat" element={<PrixAchat />} />
            <Route path="/ajouterAchats" element={<AjouterAchats />} />
            <Route path="/allQuotation" element={<SupplierQuotations />} />
            <Route
              path="/getDocumentByRef"
              element={<ProductsByPurchaseDocument />}
            />
            <Route
              path="/historiqueLivraison"
              element={<LivraisonDocumentToStock />}
            />
            <Route
              path="/warehouseMouvement"
              element={<WarehouseMouvement />}
            />
            <Route path="/bonreception" element={<ListBonReception />} />
            <Route path="/Recap" element={<Recap />} />
            {/* <Route path="/RecapAllZones" element={<RecapAllZones />} /> */}
            <Route path="/bonsortie" element={<ListBonSortie />} />
            <Route path="/bonretour" element={<ListBonRetour />} />
            <Route path="/addBDC" element={<AddBDC />} />
            <Route path="/addMagasin" element={<AddMagasin />} />
            <Route path="/bonsDeCommande" element={<BDCs />} />
            <Route path="/addFacture" element={<AddFacture />} />
            <Route path="/addFactureImport" element={<AddFactureImport />} />

            <Route path="/factures" element={<Factures />} />
            <Route path="/addPurchaseOrder" element={<AddPurchaseOrder />} />
            <Route path="/allPurchaseOrders" element={<PurchaseOrders />} />
            <Route path="/demandesAchat" element={<DemandesAchat />} />
            <Route path="/addDemandeAchat" element={<AddDemandeAchat />} />
            <Route path="/demandeAchatDetail/:id" element={<DemandeAchatDetail />} />
            <Route
              path="/generateFactureThrowPurchasesOrders"
              element={<GenerateFactureForPurchasesOrders />}
            />
            <Route
              path="/validateDevisBDCVente"
              element={<ValidateDevisToBCVente />}
            />
            <Route
              path="/validateBDCFactureVente"
              element={<ValidateBCtoFactureVente />}
            />
            {/* Vente */}
            <Route
              path="/ajouter-colis-livraison"
              element={<AddColisLivraison />}
            />
            <Route
              path="/ajouter-config-livraison"
              element={<AddConfigColis />}
            />
            <Route
              path="/configuration-colis-livraison"
              element={<ConfigColis />}
            />
            {/* emails config */}
            <Route
              path="/ajouter-config-emails"
              element={<AddConfigEmailsSociete />}
            />
            <Route
              path="/configuration-emails-societe"
              element={<ConfigEmailsSociete />}
            />
            <Route path="/colis-livraison" element={<ColisLivraison />} />
            <Route path="/kpisale" element={<KPISale />} />
            <Route path="/KPISaleDevis" element={<KPISaleDevis />} />
            <Route path="/kpisaleproduct" element={<KPISaleProduct />} />
            <Route path="/allDevis" element={<AllDevis />} />
            <Route path="/addDevis" element={<AddDevis />} />
            <Route path="/addDevisPrice" element={<AddDevisPrice />} />
            <Route path="/productSell" element={<ProductSell />} />
            <Route
              path="/addProductStockToSell"
              element={<AddProductStockToSell />}
            />
            <Route path="/bonCommandeVente" element={<BDCSell />} />
            <Route path="/suiviLivraisons" element={<SuiviLivraisons />} />
            <Route
              path="/ModifierBonCommandeVente"
              element={<BDCSellUpdate />}
            />
            <Route path="/maSociete" element={<MaSociete />} />
            <Route path="/addBDCSell" element={<AddBDCSell />} />
            <Route path="/addBDCSellDepot" element={<AddBDCSellDepot />} />
            <Route path="/allFactureSell" element={<AllFactureSell />} />
            <Route path="/addFactureSell" element={<AddFactureSell />} />
            <Route
              path="/addFactureAvrDepot"
              element={<AddFactureAvrDepot />}
            />
            <Route
              path="/addFactureSellDepot"
              element={<AddFactureSellDepot />}
            />
            <Route path="/sendPurchaseOrder" element={<SendPurchaseOrder />} />
            <Route
              path="/sendAllProducts"
              element={<SendAllProductsPurchaseOrder />}
            />
            <Route path="/retourSalesOrder" element={<ReturnSalesOrder />} />
            <Route
              path="/getDocumentSalesByRef"
              element={<ProductsBySaleDocument />}
            />
            <Route path="/EditDocumentSalesByRef" element={<EditBDCSell />} />
            {/* Service */}
            <Route
              path="/getListSocieteAchat"
              element={
                <AddBCListSociete
                  typeSociete="CLIENT"
                  typeClient="FOURNISSEUR"
                />
              }
            >
              {/**/}
            </Route>
            <Route
              exact
              path="/listBCValidated"
              element={<ListBCValidated />}
            />
            <Route path="/kpipayements" element={<KPIPayements />} />
            <Route path="/addBCAchat" element={<AddBCAchat />} />
            <Route exact path="/viewBCDetails" element={<ViewBCDetails />} />
            <Route
              exact
              path="/getListSocieteAchatAllBC"
              element={
                <ListSocieteForBC
                  typeSociete="CLIENT"
                  isIncome="AllBCAchat"
                  typeClient="FOURNISSEUR"
                />
              }
            />
            <Route
              exact
              path="/getListSocieteAchatBill"
              element={
                <AddBillListSociete
                  typeSociete="CLIENT"
                  typeClient="FOURNISSEUR"
                />
              }
            />
            <Route path="/predection" element={<Predection />} />
            <Route
              path="/payerAllBills"
              element={
                <PayementAllBills typeSociete="CLIENT" isIncome="ACHAT" />
              }
            />
            <Route
              path="/payerBillVente"
              element={<PayementBillVenteDetails />}
            />
            <Route
              path="/payerAvanceBC"
              element={<PayerAvanceBC typeSociete="CLIENT" isIncome="ACHAT" />}
            />
            {/* ---------------------- Salaires------------------- */}
            <Route path="/salairesPayement" element={<PayementSalaires />} />
            <Route path="/ajouterAvance" element={<AddNewAvance />} />
            <Route path="/ajouterSalaire" element={<AddNewSalaire />} />
            <Route path="/payerSalaire" element={<PayerSalaire />} />
            {/* ---------------------- Charge------------------- */}
            <Route path="/chargesEtat" element={<PayementCharges />} />
            <Route
              path="/clientSoldeWallet"
              element={<ClientWalletAndSolde />}
            />
            <Route path="/ajouterCharge" element={<AddCharge />} />
            <Route path="/payerCharges" element={<AddPayementCharge />} />
            {/* Marketing */}
            <Route
              path="/conditionscommercials"
              element={<ListConditionsCommercialsB2B />}
            />
            <Route
              path="/addConditionCommercial"
              element={<AddConditionCommercial />}
            />
            <Route
              path="/conditionscommercialsTiers"
              element={<ListConditionsCommercialsB2BTiers />}
            />
            <Route
              path="/addConditionCommercialTiersClient"
              element={<AddConditionCommercialTiersClient />}
            />
            <Route
              path="/addConditionCommercialTiersFournisseur"
              element={<AddConditionCommercialTiersFournisseur />}
            />
            <Route path="/pack" element={<Pack />} />
            <Route path="/addPack" element={<AddPack />} />
            <Route
              path="/addPackComposition"
              element={<AddPackComposition />}
            />
            <Route path="/AddFreePack" element={<AddTesteur />} />
            <Route path="/addDiscount" element={<AddDiscount />} />
            <Route path="/addDeclencheur" element={<AddDeclencheur />} />
            <Route path="/discount" element={<Discounts />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/">
              <Route path="Client">
                <Route index element={<PageClient />} />
                <Route path="AddClient" element={<AddClient />} />
              </Route>

              <Route path="Campagne">
                <Route index element={<PageCampagne />} />
                <Route path="PageCampagneR">
                  <Route index element={<PageCampagneR />} />
                  <Route path="AddCampagneR" element={<AddCampagneR />} />
                  <Route path="Voir/:id" element={<StatCampagneR />} />
                </Route>

                <Route path="PageCampagnePhy">
                  <Route index element={<PageCampagnePhy />} />
                  <Route path="AddCampagnePhy" element={<AddCampagnePhy />} />
                  <Route path="Voir/:id" element={<StatCampagnePhysique />} />
                </Route>

                <Route path="PageCampagneE">
                  <Route index element={<PageCampagneE />} />
                  <Route path="AddCampagneE" element={<AddCampagneE />} />
                  <Route path="Edit/:id" element={<EditCampagneE />} />
                  <Route path="Voir/:id" element={<StatCampagneE />} />
                </Route>

                <Route path="PageCampagneS">
                  <Route index element={<PageCampagneS />} />
                  <Route path="AddCampagneS" element={<AddCampagneS />} />
                  <Route path="Edit/:id" element={<EditCampagneS />} />
                  <Route path="Voir/:id" element={<StatCampagneSMS />} />{" "}
                </Route>
              </Route>
              <Route path="/PagePublication" element={<PagePublication />} />
              <Route path="/AddPublication" element={<AddPublication />} />

              {/* <Route path="/AddPublication" element={<AddPublication />} /> */}
              <Route path="/VoirPublication" element={<StatPublication />} />

              <Route path="/cartesCadeaux" element={<CartesCadeau />} />
              <Route
                path="/CartesCadeauDetails"
                element={<CartesCadeauDetails />}
              />
              <Route
                path="/AbonnementDetails"
                element={<AbonnementDetails />}
              />

              <Route path="/addCarteCadeau" element={<AddCarteCadeau />} />
              <Route path="/addPromoCaisse" element={<AddPromo />} />

              <Route path="/ListeOffres" element={<ListeOffres />} />
              <Route path="/promoSurCaisse" element={<PromoSurCaisse />} />
              <Route path="/promoGroupDetails" element={<PromoGroupDetails />} />

              <Route path="/abonnements" element={<Abonnements />} />
              <Route path="/addAbonnement" element={<AddAbonnement />} />
            </Route>
            {/* RESSOURCE HUMAINE */}
            <Route path={"/dashboardRH"} element={<DashboardRH />} />
            {/*  EMPLOYEE RH LIST */}
            <Route path={"/employeeList"} element={<EmployeeList />} />
            <Route path={"/addemployee"} element={<AddEmployee />} />
            <Route path={"/ficheEmployee"} element={<EmployeeFolder />} />
            {/*  CONTRACT ROUTES */}
            <Route path={"/contractList"} element={<ContractList />} />
            <Route path={"/addContract"} element={<AddContract />} />
            <Route path={"/contractDetail"} element={<ContractDetail />} />
            <Route path={"/crewList"} element={<CrewList />} />
            <Route path={"/addCrew"} element={<AddCrew />} />
            <Route path={"/employee_by_crew"} element={<EmployeebyCrew />} />
            <Route path={"/time_planing"} element={<TimePlanning />} />
            <Route path={"/ordreDeMission"} element={<Missionlist />} />
            <Route path={"/addmission"} element={<AddMission />} />
            <Route
              path={"/employeemissionlist"}
              element={<Employeemissionlist />}
            />
            <Route path={"/missionDetails"} element={<MissionDetails />} />
            <Route path={"/mission_interne"} element={<InternMissionlist />} />
            <Route
              path={"/add_intern_mission"}
              element={<Addinternmission />}
            />
            <Route
              path={"/detailDeContratDePartage"}
              element={<InternMissionDetails />}
            />
            <Route path={"/paimentSettigs"} element={<PaiementSettings />} />
            {/*  DEPARTEMENT ROUTES */}
            <Route path={"/departmentList"} element={<Departmentlist />} />
            <Route path={"/addDepartment"} element={<AddDepartment />} />
            <Route path={"/crewByDept"} element={<CrewbyDepartment />} />
            <Route path={"/ficheDePaie"} element={<Paiement />} />
            <Route path={"/Attendance_list"} element={<AttendanceList />} />
            <Route path={"/LeaveRequests"} element={<AllLeaveRequests />} />
            <Route
              path={"/historiquefichedepaie"}
              element={<HistoriqueFicheDePaie />}
            />
            {/* Employe Rh Dashboard */}
            <Route path="employeDashboard" element={<EmployeeDashboard />} />
            <Route
              path="leaverequestslist"
              element={<EmployeeLeaveRequests />}
            />
            <Route path="/employeeCrew" element={<EmployeeCrew />} />
            <Route path="leaveRequest" element={<LeaveRequest />} />
            {/* Employe Rh Dashboard */}
            <Route path={"/postList"} element={<PostList />} />
            <Route path={"/addpost"} element={<AddPost />} />
            <Route path={"/contracttype"} element={<ContractTypeList />} />
            <Route path={"/addcontracttype"} element={<AddContractType />} />
            <Route path={"/primelist"} element={<Primelist />} />
            <Route path={"/addprime"} element={<Addprime />} />
            <Route path={"/LeaveTypeList"} element={<LeaveTypeList />} />
            <Route path={"/AddLeaveType"} element={<AddLeave />} />
            <Route
              path={"/fichedepaieparsalaire"}
              element={<FicheDePaieSelonSalaire />}
            />
            <Route path="/listSocieteAchat" element={<ListSocieteAchatFN />} />
            <Route path="/listSocieteVente" element={<ListSocieteVenteFN />} />
            <Route path="/PayementGroupe" element={<PayementGroupe />} />
            <Route path="/listClientSolde" element={<ListClientSolde />} />
            <Route path="/ficheClient" element={<FicheClient />} />
            <Route path="/ficheFounisseur" element={<FicheFournisseur />} />

            <Route
              path="/facturesClient"
              element={<ListFactureFicheClient />}
            />

             <Route
              path="/facturesFournisseur"
              element={<ListFactureFicheFournisseur />}
            />
            <Route path="/FactureSellEtat" element={<FactureSellEtat />} />
            <Route path="/listBordereau" element={<ListBordereau />} />
            <Route path="/bordereauDetails" element={<BordereauDetails />} />
            <Route
              path="/dataTableBordereauDetails"
              element={<DataTableBordereauDetails />}
            />
            <Route
              path="/detailsTransactionAccountClient"
              element={<DetailsSoldeClient />}
            />
            <Route
              path="/detailsImpayesAccountClient"
              element={<DetailsImpayesClient />}
            />


             <Route
              path="/detailsImpayesAccountFournisseur"
              element={<DetailsImpayesFournisseur />}
            />
            <Route
              path="/detailsEcheanceClient"
              element={<DetailsPayementsClient />}
            />

              <Route
              path="/detailsEcheanceFournisseur"
              element={<DetailsPayementsFournisseur />}
            />
            <Route
              path="/detailsTransactionAccountFournisseur"
              element={<DetailsSoldeFournisseur />}
            />
            <Route
              path="/listFournisseurSolde"
              element={<ListFournisseurSolde />}
            />
            <Route path="/listBillAchat" element={<ListBillAchatV2 />} />
            <Route path="/listBillVente" element={<ListBillVenteV2 />} />
            <Route
              path="/payerAllBills"
              element={
                <PayementAllBills typeSociete="CLIENT" isIncome="ACHAT" />
              }
            />
            <Route path="/payerBill" element={<PayementBillDetails />} />
            <Route
              path="/payerAvanceBCSell"
              element={<PayerAvanceBCSell typeSociete="CLIENT" />}
            />
            {/* Production Order / Ordre de production */}
            <Route path="/productsProd" element={<ProductsListPage />} />
            <Route path="production-orders" element={<ProductionOrderList />} />
            <Route path="work-orders/:id" element={<WorkOrderDetailsPage />} />
            <Route
              element={<NewProductionOrder />}
              path="production-orders/new"
            />
            <Route
              element={<ProductionOrderDetails />}
              path="production-orders-details"
            />
            <Route element={<WorkOrderForPOList />} path="work-orders-po" />
            <Route element={<WorkOrdersDetails />} path="workOrdersDetails" />
            <Route
              element={<DetailsOperationExecutionBySup />}
              path="operationExecutionDetails"
            />
            <Route
              element={<ProductionSchedulePage />}
              path="production-plan/schedule"
            />
            <Route
              element={<SendProductionOrder />}
              path="/sendProductionOrder"
            />

<Route
              element={<KPIProductionOrder />}
              path="/kpiProductionOrder"
            />
            <Route
              element={<GetFinalProductionOrder />}
              path="/getFinalProductionOrder"
            />
            {/* operation execution */}
            <Route path="/OperationsJour" element={<OperationExecution />} />
            <Route
              path="/DetailsOperationsJour"
              element={<DetailsOperationExecution />}
            />
            <Route path="/workOrdersSteps" element={<WorkOrdersSteps />} />
            {/* Bill Of Materials / Nomenclature */}
            <Route element={<BOMList />} path="/bom" />
            <Route element={<NewBOM />} path="/newBom" />
            <Route element={<BOMDetails />} path="/detailsBom" />
            <Route element={<UpdateBOM />} path="/updateBom" />
            {/* Unit of Mesure */}
            <Route element={<AllUnitOfMesure />} path="/uom" />
            <Route element={<NewUnitOfMesure />} path="/uom/new" />
            {/* Operations */}
            <Route element={<OperationsList />} path="/operations" />
            <Route element={<UpdateOperation />} path="/updateOperation" />

            <Route element={<NewOperation />} path="/operations/new" />
            <Route element={<OperationsDetails />} path="/operations/details" />
            {/* Workstations / Station de travail */}
            <Route element={<WorkstationList />} path="/workstations" />
            <Route element={<NewWorkstation />} path="/workstations/new" />
            <Route
              element={<WorkstationDetails />}
              path="/workstationsDetails"
            />
            <Route
              element={<WorkstationOperations />}
              path="/workstationsOperations"
            />
            {/* vente B2C */}
            <Route element={<CashRegister />} path="/caisses" />
            <Route element={<TicketCaisse />} path="/ticket-caisse" />
            <Route element={<Shop />} path="/magasins" />
            <Route element={<EtatMagasin />} path="/EtatMagasin" />
            <Route element={<ManagerShop />} path="/managers-magasin" />
            <Route element={<TicketShop />} path="/tickets-magasin" />
            <Route element={<EchangePaiementTicket />} path="/echangePaiementTicket" />
            <Route element={<EchangePaiementTraite />} path="/echangePaiementTraite" />

            <Route element={<CreditShop />} path="/credit-magasin" />
            <Route element={<TraiteShop />} path="/traite-magasin" />

            <Route element={<ClientsVente />} path="/clients-vente" />
            <Route
              element={<ClientsVenteDetails />}
              path="/details-client-vente"
            />
            <Route element={<AddShop />} path="/ajoutermagasins" />
            <Route path="/journal-caisse" element={<JournalCaisse />} />
            {/* directeur de magasin*/}
            <Route element={<ShopManagers />} path="/magasins-directeur" />
            <Route
              element={<CashRegisterManagers />}
              path="/caisses-directeur"
            />
            <Route
              path="/allBanqueAccounts-directeur"
              element={<AllBanqueAccountsManagers />}
            />
            <Route
              path="/WarehousesManagers-directeur"
              element={<WarehousesManagers />}
            />
            <Route
              path="/warehouseStats"
              element={<WarehouseStats />}
            />
            <Route
              path="/alimenter-caisse"
              element={<AlimentationCaisseManagers />}
            />
             <Route
              path="/chercherTicket"
              element={<RechercheTicket />}
            />


             <Route
              path="/payerTraite"
              element={<PayerTraite />}
            />
          </Routes>
        </Menu>
        <Snackbar
          open={openErrorAlert}
          autoHideDuration={2000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleEroorClose} severity="info">
            {errorAlertText}
          </Alert>
        </Snackbar>
      </div>
    );
  else return <Login></Login>;
}

export default App;
